import React from 'react';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { LabourItemGroupDetails } from '../api/labourItemGroupsApi';
import { useLabourGroupsPanelStore } from '../stores/labourGroupsPanelStore';
import { GroupOverviewCard } from './panel/molecules/GroupOverviewCard';
import { GroupLabourItemsCard } from './panel/molecules/GroupLabourItemsCard';
import { GroupActions } from './panel/molecules/GroupActions';

interface GroupDetailsPanelProps {
  group: LabourItemGroupDetails | null;
  loading?: boolean;
}

const GroupDetailsPanel: React.FC<GroupDetailsPanelProps> = ({
  group,
  loading = false,
}) => {
  const switchMode = useLabourGroupsPanelStore(state => state.switchMode);
  const setEditedGroupName = useLabourGroupsPanelStore(
    state => state.setEditedGroupName
  );

  const handleEditClick = () => {
    if (group) {
      setEditedGroupName(group.name);
      switchMode('edit');
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      {loading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            p: 1,
          }}
          data-testid="group-details-loading"
        >
          <CircularProgress />
        </Box>
      ) : group ? (
        <Stack spacing={3} data-testid="group-details-content">
          {/* Group Overview Card */}
          <GroupOverviewCard group={group} />

          {/* Labour Items Card */}
          <GroupLabourItemsCard labourItems={group.labourItems || []} />

          {/* Actions Card */}
          <GroupActions onEdit={handleEditClick} />
        </Stack>
      ) : (
        <Typography variant="body2" color="text.secondary" align="center">
          No group details available
        </Typography>
      )}
    </Box>
  );
};

export default GroupDetailsPanel;
